import { computed, toRefs } from 'vue';
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const {
      data
    } = toRefs(props);
    const list = computed(() => ['d', 'h', 'm', 's'].reduce((res, key) => {
      if (key === 'd' && data.value[key] === '00') {
        return res;
      }
      if (data.value[key]) {
        return [...res, ...data.value[key].toString().split('')];
      }
      return res;
    }, []));
    return {
      list
    };
  }
};